import styled from 'styled-components';
import MuiPaper from '@mui/material/Paper';

export const Paper = styled(MuiPaper)`
  margin-bottom: 1rem;
`;
